import { IPinpadService } from "modules/payment/application/interfaces/IPinpadService";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { isReactNative } from "utils/constants";
import { isAdyenForcedEnabled } from "Infrastructure/repositories/localStorage/adyenFlag";
import { PaymentAcquirerType } from "./acquirerType";
import { AdyenPaymentRepository } from "Infrastructure/services/adyenService/AdyenPaymentRepository";
import { ReactNativePaymentRepository } from "Infrastructure/services/reactNativeServices/ReactNativePaymentService";
import { CefSharpPaymentRepository } from "Infrastructure/services/cefSharpService/local/CefSharpPaymentRepository";

export const resolvePinpadService = (kiosk?: Kiosk): IPinpadService => {
  const shouldUseAdyen = isAdyenForcedEnabled() || kiosk?.tipoAdquirente === PaymentAcquirerType.Adyen;

  if (shouldUseAdyen) {
    return AdyenPaymentRepository();
  }

  return isReactNative ? ReactNativePaymentRepository() : CefSharpPaymentRepository();
};
